import { AppUI } from '@seedlang/state';
import React from 'react';

class PageTitle extends React.Component {
  componentDidMount() {
    this.updateTitle();
  }

  componentDidUpdate() {
    this.updateTitle();
  }

  componentWillUnmount() {
    if (AppUI.site?.teamName) {
      document.title = AppUI.site.teamName;
    }
  }

  updateTitle() {
    const { children } = this.props;
    if (children && AppUI.site?.teamName) {
      document.title = `${children} | ${AppUI.site.teamName}`;
    } else if (children) {
      document.title = children;
    }
  }

  render() {
    return null;
  }
}

export default PageTitle;